<div
    class="resize-column-field"
    webColumnWidth
    [isColumnWidthFlex]="isColumnWidthFlex()"
    [columnLeft]="columnLeft()"
    [columnRight]="columnRight()"
    [style.right.px]="rightStyle()"
    (changeWidthToLeftEvent)="changeWidthToLeftEvent.emit()"
    (changeWidthToRightEvent)="changeWidthToRightEvent.emit()"
>
    <button class="resize-column-btn">
        <img src="./assets/img/websites/lpc-resize-column-icon.svg" alt="resize" />
    </button>
</div>
